import React from "react";
import "./ImportResultsDisplay.css";

const ImportResultsDisplay = ({ results, onClose, entityLabel = "entrée" }) => {
  if (!results) return null;

  const {
    success,
    entrees_creees = 0,
    sorties_creees = 0,
    produits_crees,
    erreurs,
    parsing_errors,
    erreurs_creation,
    message,
    aide,
  } = results;

  const createdCount = entrees_creees || sorties_creees || 0;
  const entityPlural = `${entityLabel}(s)`;

  const normalizedCreationErrors = Array.isArray(erreurs_creation)
    ? erreurs_creation
    : Array.isArray(erreurs)
      ? erreurs
      : [];

  const normalizedParsingErrors = Array.isArray(parsing_errors)
    ? parsing_errors.flatMap((item) => {
        if (typeof item === "string") {
          return [{ lignes: [], erreur: item }];
        }
        return (item?.erreurs || []).map((err) => ({
          lignes: [item?.ligne].filter(Boolean),
          entree: item?.entree || null,
          sortie: item?.sortie || null,
          erreur: err,
        }));
      })
    : [];

  const allErrors = [...normalizedCreationErrors, ...normalizedParsingErrors];
  const hasErrors = allErrors.length > 0;
  const hasGlobalMessage = Boolean(message && String(message).trim());
  const isFailure = !success || createdCount === 0;

  return (
    <div className="import-results-container">
      <div
        className={`import-summary ${
          success && createdCount > 0 ? "success" : "failure"
        }`}
      >
        <div className="summary-icon">
          {success && createdCount > 0 ? "✅" : "❌"}
        </div>
        <div className="summary-text">
          <h3>
            {success && createdCount > 0
              ? "Import réussi"
              : "Import annulé — rien n'a été créé"}
          </h3>
          <p>
            {success && createdCount > 0
              ? `${createdCount} ${entityPlural} créée(s) • ${produits_crees} produit(s) créé(s)`
              : `Aucune ${entityLabel} enregistrée. Corrigez le fichier puis relancez l'import.`}
          </p>
        </div>
      </div>

      {success && createdCount > 0 && (
        <div className="import-details">
          <div className="detail-item">
            <span className="detail-label">
              {entityLabel.charAt(0).toUpperCase() + entityLabel.slice(1)}s créées :
            </span>
            <span className="detail-value">{createdCount}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Produits créés :</span>
            <span className="detail-value">{produits_crees}</span>
          </div>
        </div>
      )}

      {(hasErrors || hasGlobalMessage || isFailure) && (
        <div className="import-errors">
          <h4>Erreurs détectées ({allErrors.length || 1})</h4>

          {hasGlobalMessage && (
            <div className="error-item error-item--global">
              <div className="error-message">{message}</div>
            </div>
          )}

          {aide?.regle_tout_ou_rien && (
            <div className="error-item error-item--info">
              <div className="error-message">{aide.regle_tout_ou_rien}</div>
            </div>
          )}

          {hasErrors && (
            <div className="errors-list">
              {allErrors.map((erreur, index) => (
                <div key={index} className="error-item">
                  <div className="error-header">
                    {erreur?.lignes && erreur.lignes.length > 0 && (
                      <span className="error-ligne">
                        Ligne(s) {erreur.lignes.join(", ")}
                      </span>
                    )}
                    {(erreur?.entree || erreur?.sortie) && (
                      <span className="error-entree">
                        {erreur.entree || erreur.sortie}
                      </span>
                    )}
                  </div>
                  <div className="error-message">
                    {erreur?.erreur ||
                      erreur?.erreurs?.join(", ") ||
                      "Erreur inconnue"}
                  </div>
                  {erreur?.conseil && (
                    <div className="error-conseil">{erreur.conseil}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="import-actions">
        <button type="button" className="btn-close-results" onClick={onClose}>
          Fermer
        </button>
      </div>
    </div>
  );
};

export default ImportResultsDisplay;
